import React from 'react'

const Recruitment = () => {
  return (
    <div className='mx-auto p-4'>
      Recruitment
    </div>
  )
}

export default Recruitment
